import React from 'react';
import { useParams } from 'react-router-dom';

import { ConsolidatedForecastingContext } from '../../forecast/detail/context/consolidated-forecasting-context';
import { ConsolidationDataContext } from '../context/consolidation-data-context';
import { PredictConsolidationManagement } from '../components/consolidation/predict-consolidation-management';

export const PredictConsolidationManagementContainer = () => {
  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisationId } = useParams();
  const workspaceId = tempWorkspaceId as string;
  const organisationId = tempOrganisationId as string;

  return (
    <ConsolidationDataContext consolidationId={organisationId} workspaceId={workspaceId}>
      <ConsolidatedForecastingContext>
        <PredictConsolidationManagement />
      </ConsolidatedForecastingContext>
    </ConsolidationDataContext>
  );
};
